import * as api from '@/api';
import store from '@/store';

let intervalId;

function check() {
    api.invitations.all().then(response => {
        store.commit('setInvitations', response.data);
    });
}

export default {
    start() {
        check();
        intervalId = window.setInterval(check, 60000);
    },
    stop() {
        window.clearInterval(intervalId);
    },
    clear() {
        store.commit('setInvitations', []);
    },
    now() {
        check();
    },
};
